import * as React from 'react';

import {ErrorState} from 'shells/error-state/error-state';
import {PageContentTwoColumn} from 'shells/layout/page-content-two-column';
import {LoadingPage} from 'shells/loading-page/loading-page';
import {PreviewWithEdit} from 'shells/preview-with-edit/preview-with-edit';
import {LabelWithContent} from 'shells/typography/label-with-content';

import type {LandingPageFullFragment} from 'nutshell-graphql-types';

import {HostingSection} from '../hosting-section/hosting-section';

type Props = {
    page: LandingPageFullFragment | null | undefined;
    isLoading: boolean;
    errorMessage: string | null | undefined;
};

export function PageTab(props: Props) {
    return (
        <>
            {props.errorMessage && <ErrorState errorMessage={props.errorMessage} />}
            {props.isLoading && !props.page && <LoadingPage />}
            {props.page && (
                <PageContentTwoColumn
                    withoutOuterPadding={true}
                    leftContent={
                        <LabelWithContent
                            label='Page'
                            spacing={8}
                            isFullHeight={true}
                            content={
                                <PreviewWithEdit
                                    noun='page'
                                    to={`/email-marketing/landing-pages/${props.page.id}/editor`}
                                    preview={
                                        <img
                                            // @ts-expect-error
                                            src={props.page.thumbnailUrl}
                                            alt={props.page.name}
                                            className='full-width'
                                        />
                                    }
                                    backgroundColor={props.page.backgroundColor}
                                />
                            }
                        />
                    }
                    rightContent={
                        <LabelWithContent
                            label='Hosting'
                            spacing={8}
                            isFullHeight={true}
                            content={
                                <HostingSection
                                    customPublishedUrl={props.page.customPublishedUrl}
                                    subdomainRecord={props.page.subdomainRecord}
                                    nutshellPublishedUrl={props.page.nutshellPublishedUrl}
                                    pageId={props.page.id}
                                    urlSlug={props.page.urlSlug}
                                />
                            }
                        />
                    }
                />
            )}
        </>
    );
}
